import { useCallback } from "react";
import { useStreamingAvatarStore } from "@/features/avatar/lib/useStreamingAvatarStore";

export const useConversationState = () => {
    const { avatar, isAvatarTalking, isUserTalking, isListening } =
        useStreamingAvatarStore();

    const startListening = useCallback(() => {
        if (!avatar) return;
        avatar.startListening();
    }, [avatar]);

    const stopListening = useCallback(() => {
        if (!avatar) return;
        avatar.stopListening();
    }, [avatar]);

    return {
        isAvatarListening: isListening,
        startListening,
        stopListening,
        isUserTalking,
        isAvatarTalking,
    };
};
